import React from "react";
import styles from "./MenuListTitle.module.css";

export default function MenuListTitle({ menuItem }) {
	return <span className={styles.menuListTitle}>{menuItem}</span>;
}
